import { render, staticRenderFns } from "./FinanceDemoLayout.vue?vue&type=template&id=12fa8736&scoped=true&"
import script from "./FinanceDemoLayout.vue?vue&type=script&lang=js&"
export * from "./FinanceDemoLayout.vue?vue&type=script&lang=js&"
import style0 from "./FinanceDemoLayout.vue?vue&type=style&index=0&id=12fa8736&lang=scss&scoped=true&"
import style1 from "./FinanceDemoLayout.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12fa8736",
  null
  
)

export default component.exports